import { createApp } from 'vue';

import App from './App.vue';
import components from './mixins/components';
import axiosInit from './plugins/axios';
import matomo from './plugins/matomo-plugin';
import CookieConsent from './plugins/CookieConsent';
import router from './router';
import store from './store';
import eventTracking from './plugins/eventTracking';

const baseUrl =
  (process.env.NODE_ENV == 'development' ? 'https://siresca-backend.ddev.site/wp-json' : '/api/?rest_route=') +
  '/siresca/v1/';

async function initApp() {
  var app = createApp(App).use(store).mixin(components);

  const axiosClient = axiosInit({
    baseUrl,
    app
  });

  app.provide('axios', axiosClient);

  const r = router(app, store, axiosClient);
  app.use(r)
  .use(CookieConsent, {axiosClient})
  .use(eventTracking)
  .use(matomo, { router: r }).mount('#app');
}

initApp();
